export default {
  meta: {
    title: '价格管理'
  }
};
